<template>
  <v-card>
    <v-card-title>
      {{isHidden ? 'Suite group Suites' : 'Edit Suite group Suites'}}
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-subheader v-if="!isHidden">
          <v-checkbox
            v-model="all"
            label="Suites"
            readonly
            @change="selectAll"
          ></v-checkbox>
          <div class="search">
            <v-text-field
              color="primary"
              label="Filter Suites"
              class="xs6"
              v-model="search"
              @input="filterSuites"
            ></v-text-field>
          </div>
        </v-subheader>
        <v-list class="suite-list">
          <v-list-tile href="javascript:;" v-for="(suite, index) in filteredSuites" :key="index" @click="selectSuite(suite.id)">
            <v-list-tile-action v-if="!isHidden">
              <v-checkbox
                :input-value="suite.selected"
              ></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{suite.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-form>
    </v-card-text>
    <v-layout column align-end class="px-2">
      <a
        v-if="!isHidden"
        @click.prevent="submit"
        class="modal-button black--text"
        :disabled="!valid">
        <v-btn :disabled="!valid" fab dark small color="primary">
          <v-icon dark>arrow_forward</v-icon>
        </v-btn>
        Submit
      </a>  
      <a
        @click.prevent="$emit('close')"
        class="modal-button black--text">
        <v-btn fab dark small color="accent">
          <v-icon dark>close</v-icon>
        </v-btn>
        Close
      </a>
    </v-layout>
  </v-card>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    props: ['suiteGroup', 'isHidden'],
    data: () => ({
      valid: true,
      suites: [],
      filtered: [],
      search: '',
      all: false,
    }),
    computed: {
      filteredSuites() {
        if (this.isHidden) return this.suiteGroup.suites;
        return this.search.length > 0 ? this.filtered : this.suites;
      },
    },
    methods: {
      selectAll() {
        if (this.search.length > 0) {
          this.suites = this.suites.map((suite) => {
            const current = suite;
            // eslint-disable-next-line
            for (const filtered of this.filtered) {
              if (suite.id === filtered.id) {
                current.selected = this.all;
                break;
              }
            }
            current.selected = current.selected === this.all ? current.selected : false;
            return current;
          });
        } else {
          this.suites = this.suites.map((suite) => {
            const current = suite;
            current.selected = this.all;
            return current;
          });
        }
      },
      selectSuite(id) {
        if (this.isHidden) return;
        this.suites = this.suites.map((current) => {
          const suite = current;
          if (suite.id === id) {
            suite.selected = !suite.selected;
          }
          return suite;
        });
        this.all = false;
      },
      filterSuites(value) {
        this.filtered = this.suites.filter(suite =>
          suite.name.toLowerCase().includes(value.toLowerCase()));
      },
      async submit() {
        console.log(this.suiteGroup);
        const suiteGroup = {
          id: this.suiteGroup._id || this.suiteGroup.id,
        };
        const suites = [];
        this.suites.forEach((suite) => {
          if (suite.selected) {
            suites.push(suite);
          }
        });
        Object.assign(suiteGroup, { suites: suites.map(suite => suite.id) });

        const res = await webHelper.put(this, 'suite-group/suites', suiteGroup);
        if (res.failed) {
          this.err = 'Failed to add suites';
          return;
        }
        this.$emit('submit', Object.assign({}, this.suiteGroup, suiteGroup, { suites }));
      },
    },
    watch: {
      search(newVal) {
        const search = newVal.length > 0 ? this.filtered : this.suites;
        const selected = search.reduce((accumulated, current) => {
          if (current.selected) return accumulated + 1;
          return accumulated;
        }, 0);
        if (selected === search.length && selected !== 0) {
          this.all = true;
        } else {
          this.all = false;
        }
      },
    },
    async created() {
      const res = await webHelper.get(this, 'suite/available');
      if (res.failed) {
        this.err = 'Error getting Suites.';
      }
      this.suites = res.suites.map(suite => ({
        id: suite._id,
        name: suite.name,
        selected: false,
      }));
      if (this.suiteGroup) {
        this.suites.unshift(...this.suiteGroup.suites.map(suite => ({
          id: suite._id,
          name: suite.name,
          selected: true,
        })));
      }
    },
  };
</script>

<style scoped>
  .suite-list {
    max-height: 200px;
    overflow-y: auto;
  }
  .search {
    width: 50%;
    margin-left: 5px;
  }
  .subheader {
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/SuiteList.vue